import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-trainingcarousel',
  templateUrl: './trainingcarousel.component.html',
  styleUrls: ['./trainingcarousel.component.css']
})
export class TrainingcarouselComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
